import { useState } from "react";
import { producaov2 } from "../../../../../services/apis";
import { createFormData } from "../utils";

export default function useSubmitSurvey({ surveyID }) {
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const onSubmit = async ({ values }) => {
    try {
      setLoadingSubmit(true);
      setSubmitError('');

      const formData = createFormData({ values });

      const response = await producaov2({
        method: surveyID ? 'PUT' : 'POST',
        url: surveyID ? `/admin/surveys/${surveyID}` : '/admin/surveys',
        data: formData,
        headers: {
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
        },
      });

      if(surveyID) {
        window.open('/admin/pesquisa', '_self');
      } else {
        location.replace('/admin/pesquisa');
      }

      // setLoadingSubmit(false);
    } catch (error) {
      console.log(error);
      setSubmitError(error?.response?.data?.message || error?.message);
      setLoadingSubmit(false);
    }
  };

  return {
    loadingSubmit,
    submitError,
    onSubmit,
  };
}